module.exports = new __parcel__URL__("seahorse-ios6.291e25fe.png").toString();